import { NextEventList, UserRoles } from "../utils/types";
import {
  AccountOwner,
  BusinessClient,
  BusinessClientCreate,
  GeneralData,
  Operator,
  ProductsOn,
  StoreData,
} from "../utils/typesClients";
import { apiManagement } from "./api";

export const clientListService = (
  filterType: string,
  valueFilter: string,
  sortType: string
) => {
  return apiManagement.get<BusinessClient[]>(
    `/v1/super-admin/business-client/fetch-collections/${filterType}/${valueFilter}/${sortType}`
  );
};
///v1/super-admin/business-client/fetch-collections/{filterType}/{statusFilter}/{valueFilter}/{sortType}

// /v1/super-admin/account-owner-info/{accountId}
export const acountOwnerInfoService = (accountId: string) => {
  return apiManagement.get<AccountOwner>(
    `/v1/super-admin/account-owner-info/${accountId}`
  );
};

export const toggleSignupExpress = (accountId: string) => {
  return new Promise<{ message: "ENABLED" | "DISABLED" }>((resolve, reject) => {
    apiManagement
      .put<{ message: "ENABLED" | "DISABLED" }>(
        `/v1/super-admin/business-client/update-sign-on-express/${accountId}`
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const togglePassword = (accountId: string) => {
  return new Promise<{ message: "true" | "false" }>((resolve, reject) => {
    apiManagement
      .put<{ message: "true" | "false" }>(
        `/v1/super-admin/business-client/update-field-enabled/${accountId}`
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const toggleCustomDataFields = (accountId: string) => {
  return new Promise<{ message: "true" | "false" }>((resolve, reject) => {
    apiManagement
      .put<{ message: "true" | "false" }>(
        `/v1/super-admin/business-client/update-allow-custom-fields/${accountId}`
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

export const putCustomDataFields = (
  accountId: string,
  customFields: { [key: string]: string }
) => {
  return new Promise<{ customFields: { [key: string]: string } }>(
    (resolve, reject) => {
      apiManagement
        .put<{ customFields: { [key: string]: string } }>(
          `/v1/super-admin/business-client/update-custom-fields/${accountId}`,
          { customFields }
        )
        .then((res) => resolve(res.data))
        .catch((err) => reject(err));
    }
  );
};

export const updateSignUpExpressRole = (accountId: string, role: UserRoles) => {
  return new Promise<{ message: UserRoles }>((resolve, reject) => {
    apiManagement
      .put<{ message: UserRoles }>(
        `/v1/super-admin/business-client/update-role-sign-on/${accountId}`,
        { role }
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

// /v1/super-admin/get-stores-info/{accountId}/{offSet}/{limit}/{sortType}

export const getStoreInfoService = (
  accountId: string,
  sortType: string,
  offSet: number,
  limit: number,
  storeName: string
) => {
  const queryParams = new URLSearchParams({
    storeName: storeName,
  });
  let urlService = "";
  storeName !== ""
    ? (urlService = `/v1/super-admin/get-stores-info/${accountId}/${offSet}/${limit}/${sortType}?${queryParams}`)
    : (urlService = `/v1/super-admin/get-stores-info/${accountId}/${offSet}/${limit}/${sortType}`);

  return apiManagement.get<StoreData[]>(urlService);
};
// v1/super-admin/last-events/64e414ff64f8913df746c2bd
export const getLastEventService = (accountId: string) => {
  return apiManagement.get<NextEventList[]>(
    `/v1/super-admin/last-events/${accountId}`
  );
};

///v1/super-admin/general-account-info/{accountId}

export const generalAccountInfoService = (accountId: string) => {
  return apiManagement.get<GeneralData>(
    `/v1/super-admin/general-account-info/${accountId}`
  );
};

// /v1/super-admin/operators-info-by-store/62feb214a5086b6b207be67c/0/5/DESCEND_ALPHABET?name=AR
export const getOperatorsInfoByStoreService = (
  accountId: string,
  sortType: string,
  offSet: number,
  limit: number,
  name: string
) => {
  const queryParams = new URLSearchParams({
    name: name,
  });
  let urlService = "";
  name !== ""
    ? (urlService = `/v1/super-admin/operators-info-by-store/${accountId}/${offSet}/${limit}/${sortType}?${queryParams}`)
    : (urlService = `/v1/super-admin/operators-info-by-store/${accountId}/${offSet}/${limit}/${sortType}`);

  return apiManagement.get<Operator[]>(urlService);
};

export const updateFiraProductsService = (
  accountId: string,
  body: string[]
) => {
  return apiManagement.put<ProductsOn>(
    `/v1/super-admin/business-client/update-fira-products/${accountId}`,
    body
  );
};

export const createAccountBusinessClientService = (
  body: BusinessClientCreate
) => {
  return apiManagement.post<any>(
    `/v1/super-admin/business-client/create`,
    body
  );
};

export const getBorrowedStoresService = (accountId: string, offSet: number, limit: number) => {
  return new Promise<FiraStore[]>((resolve, reject) => {
    apiManagement
      .get<FiraStore[]>(
        `/v1/fira-business/store/borrowed-stores/${accountId}/${offSet}/${limit}`
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

export const getLentStoresService = (accountId: string, offSet: number, limit: number) => {
  return new Promise<FiraStore[]>((resolve, reject) => {
    apiManagement
      .get<FiraStore[]>(
        `/v1/fira-business/store/claimable-stores/${accountId}/${offSet}/${limit}`
      )
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

export const claimStoreService = (accountId: string, stores: string[]) => {
  return new Promise((resolve, reject) => {
    const body = stores.map((storeId) => ({businessClientId: accountId, storeId: storeId}));
    apiManagement.post('/v1/fira-business/store/claim-store-list', body)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

export const returnStoreService = (accountId: string, stores: string[]) => {
  return new Promise((resolve, reject) => {
    const body = stores.map((storeId) => ({businessClientId: accountId, storeId: storeId}));
    apiManagement.post('/v1/fira-business/store/hand-back-store-list', body)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}

export const transferStoreService = (toAccountId: string, stores: string[]) => {
  return new Promise((resolve, reject) => {
    const body = stores.map((storeId) => ({businessClientId: toAccountId, storeId: storeId}));
    apiManagement.post('/v1/fira-business/store/borrow-store-list', body)
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
}
